import React from 'react';

import lang from '../../../../../../lib/language';

import noMessagesLogo from '../../../../../../assets/img/image_empty.png';
import ImageEmpty from '../../../../../../assets/img/image_empty.svg';
import useIsMobile from '../../../../../../hooks/useIsMobile';

import styles from '../AllNotifications.module.scss';

const NoMessages = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className={styles.wrapperNoMessagesLogo}>
        <img src={ImageEmpty} alt="no messages logo" />
        <p className={styles.noMessages}>{lang.commonInboxNoMessagesText2()}</p>
      </div>
    );
  }

  return (
    <>
      <div className={styles.wrapperLayout}>
        <div className={styles.wrapperMessages}>
          <h3>{lang.commonInboxTitle()}</h3>
        </div>
      </div>
      <div className={styles.wrapperNoMessagesLogo}>
        <img src={noMessagesLogo} alt="no messages logo" />
        <p className={styles.noMessages}>{lang.commonInboxNoMessagesText2()}</p>
      </div>
    </>
  );
};

export default NoMessages;
